import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {MatDialog} from '@angular/material/dialog';
import {CriteriaSearch} from 'src/app/domain/CriteriaSearch';
import {CatalogueService} from 'src/app/modules/services/catalogue/catalogue.service';
import {DetailProdPComponent} from '../detail-prod-p/detail-prod-p.component';

@Component({
    selector: 'app-hierachie-p-table',
    templateUrl: './hierachie-p-table.component.html',
    styleUrls: ['./hierachie-p-table.component.css']
})
export class HierachiePTableComponent implements OnInit {
    @Output() searchid = new EventEmitter<any>();
    @Input() list: any[] = [];
    @Input() firsttable = true;
    public data: any[] = [];

    dataSource = new MatTableDataSource<any>();
    dataSource2 = new MatTableDataSource<any>();


    readColumns: String[] = [
        'cateNm',
        //'telecharger',


    ];
    readColumns2: String[] = [
        'categorie',
        'prodId',
        'prodNm',
        'action',

    ];

    constructor(public dialog: MatDialog,
                private catalogueService: CatalogueService,
                public translate: AppTranslateService,
                private appTranslateService: AppTranslateService,) {
    }

    ngOnInit(): void {
        this.loadDataSource();
    }

    loadDataSource() {
        this.dataSource.data = this.list;
    }

    loadDataSource2() {
        this.dataSource2.data = this.data;
    }

    ngOnChanges(changes: SimpleChanges): void {

        const {list} = changes;
        if (list.currentValue !== list.previousValue) {
            this.loadDataSource();
            this.fetch();

        }

    }

    fetch() {
        this.firsttable = true;

    }

    sendID(item) {
        this.searchid.emit(item);
    }

    hamza(item) {
        this.firsttable = false;
        const searchvalue = [];
        searchvalue.push(
            new CriteriaSearch(
                'cateId',
                item || undefined,
                'upper_like'
            ));
        this.catalogueService.loadDataP({dataSearch: searchvalue})
            .subscribe(response => {

                this.data = response['payload']['data'];

                this.loadDataSource2();

            });

    }

    opendialogannonce(item) {
        const dialogRef = this.dialog.open(DetailProdPComponent, {
            disableClose: true,
            direction: this.appTranslateService.getDir(),
            width: '1500px',
            data: {...item}
        });

        dialogRef.afterClosed().subscribe(result => {


        });
    }

}
